module.exports = __webpack_public_path__ + "static/media/logo_white.ca89c710.png";